import { render, staticRenderFns } from "./lots.vue?vue&type=template&id=17f75ee4&scoped=true&"
import script from "./lots.vue?vue&type=script&lang=js&"
export * from "./lots.vue?vue&type=script&lang=js&"
import style0 from "./lots.vue?vue&type=style&index=0&id=17f75ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f75ee4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
